import { createFileRoute } from '@tanstack/react-router';

import { CitationCreate } from '@/module/Author/Citation/CitationCreate';

export const Route = createFileRoute('/_auth/author/_author/book/_book/$bookId/_layout/citations/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  const { bookId } = Route.useParams();

  return <CitationCreate publicationId={Number(bookId)} />;
}
